import React, {useLayoutEffect, useState} from 'react';
import {
    DoppePageViewerPart,
    doppePageViewerPartCreateMarkingAttributes
} from "../doppe-page-viewer-part/doppe-page-viewer-part";
import {OmitStrict, stringTrimPrefix, Values} from '@wix/devzai-utils-common';
import {classes, style} from './doppe-viewer-attribution-link.st.css';


export const SourceType = {
    PreRoll: 'banner-pre-roll',
    LandingPage: 'banner-landing-page',
    BioPage: 'banner-bio-page',
} as const;

export type SourceType = Values<typeof SourceType>;

export const DoppeViewerAttributionLink = React.memo(function DoppeViewerAttributionLink (props: DoppeViewerAttributionLink.Props) {
    const {
        targetUrl = `https://www.hopp.co`,
        sourceType,
        children,
        className,
        ...htmlAttributes
    } = props;

    // For SSR we need to add the UTM source only on layout effect, since `location` isn't accessible during rendering.
    const [attributionTargetUrl, setAttributionTargetUrl] = useState(targetUrl);
    useLayoutEffect(() => {

        const campaign = sourceType === SourceType.BioPage ?
            stringTrimPrefix(location.pathname, '/').split('/')[0] :
            location.host.split('.')[0]

        setAttributionTargetUrl(`${targetUrl}?utm_source=${sourceType}&utm_campaign=${encodeURIComponent(campaign)}&utm_medium=${encodeURIComponent(location.href)}`)
    }, [targetUrl, sourceType]);

    return (
        <a
            {...htmlAttributes}
            href={attributionTargetUrl}
            target={'_blank'}
            rel={'noopener'}
            className={style(classes.root, className)}
            {...doppePageViewerPartCreateMarkingAttributes(DoppePageViewerPart.BrandAttribution)}
        >
            {children}
        </a>
    );
});

export namespace DoppeViewerAttributionLink {

    export interface Props extends OmitStrict<React.AnchorHTMLAttributes<any>, 'href' | 'target' | 'rel'> {
        targetUrl?: string;
        sourceType: SourceType;
    }
}
